module.exports = __webpack_public_path__ + "producr-dried fresh-grass-05.jpg?8eba29239248fef54a028449755b1483";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-05.jpg
// module id = 63
// module chunks = 0